<div class="flex flex-col space-y-4 md:space-y-6 lg:space-y-8">
  @defer (on immediate) {
    <sham-slides-swiper #slidesSwiper [slides]="slides()" class="reveal" />
  } @loading {
    <section
      class="w-full aspect-2/1 xl:aspect-30/12 flex flex-col items-center justify-center space-y-2 text-base bg-blue text-white p-4"
    >
      <strong>{{ 'Welcome to Sham Super Store' | translate }}</strong>
      <small>{{ 'Loading Content...' | translate }}</small>
    </section>
  } @placeholder {
    <section
      class="w-full aspect-2/1 xl:aspect-30/12 flex flex-col items-center justify-center space-y-2 text-base bg-blue text-white p-4"
    >
      <strong>{{ 'Welcome to Sham Super Store' | translate }}</strong>
      <small>{{ 'Loading Content...' | translate }}</small>
    </section>
  }
  @if (home()?.popularCategories?.length) {
    <app-home-cards-list
      class="reveal"
      #popCats
      [title]="'Popular Categories' | translate"
      listLink="/categories"
    >
      @defer (on immediate) {
        <app-home-popular-categories />
      }
    </app-home-cards-list>
  }
  @if (home()?.recommendedForYou?.length) {
    <app-home-cards-list
      class="reveal"
      [title]="'Recommended for You' | translate"
      listLink="/home/section/recommended"
    >
      @defer (on idle) {
        <app-home-recommended-products />
      }
    </app-home-cards-list>
  }
  <section
    class="reveal content-section grid grid-cols-2 sm:grid-cols-4 gap-1 sm:gap-2 lg:gap-x-4 mx-auto w-full text-xs md:text-lg"
  >
    @for (feature of features; track feature.title) {
      <article
        class="group flex items-center gap-2 lg:gap-x-3 p-2 lg:p-3 rounded-lg border cursor-pointer transition-all duration-200 ease-in-out hover:shadow-md hover:border-b-blue active:scale-95 active:shadow-inner"
      >
        <div
          class="size-6 lg:size-14 p-1 flex items-center justify-center rounded-full bg-gray-100 text-blue transition-colors duration-200 group-hover:bg-blue group-hover:text-gray-100"
        >
          <span [class.scale-150]="$first || $last">
            <ng-container [ngComponentOutlet]="feature.icon" />
          </span>
        </div>

        <div class="space-y-1">
          <p class="font-semibold">{{ feature.title | translate }}</p>
          <p class="text-gray-400 text-3xs md:text-sm">
            {{ feature.description | translate }}
          </p>
        </div>
      </article>
    }
  </section>
  @defer (on idle) {
    <app-home-banners-ads class="reveal" [banners]="banners()" />
  }
  @if (home()?.featuredProducts?.length) {
    <app-home-cards-list
      class="reveal"
      #featuredPros
      [title]="'Featured Products' | translate"
      listLink="/home/section/featured"
    >
      @defer (on idle) {
        <app-home-featured-products />
      }
    </app-home-cards-list>
  }
  @if (home()?.bestSellers?.length) {
    <app-home-cards-list
      class="reveal"
      [title]="'Best Sellers' | translate"
      listLink="/home/section/featured"
    >
      @defer (on idle) {
        <app-home-featured-products collection="bestSellers" />
      }
    </app-home-cards-list>
  }
  @if (home()?.mostShared?.length) {
    <app-home-cards-list
      class="reveal"
      [title]="'Most Shared' | translate"
      listLink="/home/section/featured"
    >
      @defer (on idle) {
        <app-home-featured-products collection="mostShared" />
      }
    </app-home-cards-list>
  }
  @defer (on idle) {
    <app-home-sales-ads class="reveal" [banners]="salesBanners()" />
  }
  @if (home()?.greatDeals?.length) {
    <app-home-cards-list
      class="reveal"
      #onSales
      [title]="'Great Deals' | translate"
      listLink="/home/section/deals"
    >
      @defer (on idle) {
        <app-home-great-deals />
      }
    </app-home-cards-list>
  }
  @if (home()?.newArrivals?.length) {
    <app-home-cards-list
      class="reveal"
      #newArrivals
      [title]="'New Arrivals' | translate"
      listLink="/home/section/new-products"
    >
      @defer (on idle) {
        <app-home-new-products />
      }
    </app-home-cards-list>
  }
  @if (bannerImage()) {
    <sham-wide-banner class="reveal" [image]="bannerImage()" [link]="bannerLink()" />
  }
  @if (news().length) {
    <app-home-cards-list
      id="our-news"
      class="reveal"
      [title]="'Our News' | translate"
      listLink="/news"
    >
      @defer (on idle) {
        <app-home-news />
      }
    </app-home-cards-list>
  }
</div>
